// eslint-disable-next-line no-shadow
var QuizTrack;
(function (QuizTrack) {
    QuizTrack["view_quiz"] = "view_quiz";
    QuizTrack["start_quiz"] = "start_quiz";
    QuizTrack["finish_quiz"] = "finish_quiz";
    QuizTrack["email_sign_up"] = "email_sign_up";
})(QuizTrack || (QuizTrack = {}));
export default QuizTrack;
